import { render } from "./users.vue?vue&type=template&id=10ae8e64&ts=true"
import script from "./users.vue?vue&type=script&lang=ts"
export * from "./users.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__